import(/* webpackMode: "eager" */ "/workspace/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/InstallPWA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/lib/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
